import React from 'react';
import { logger } from '@MyLib/Debug/Debug.js';
import { useEffect, useState, useRef } from "react";

import { WhiteSymbol, BlueSymbol, BlackSymbol, RedSymbol, GreenSymbol, ColorlessSymbol } from "../../component/mtg/CardSymbol.jsx";
import { CardTypeList, SupertypeList, CardRarityList } from '../../component/mtg/CardSymbol.jsx';
import { CardLanguage } from '../../component/mtg/CardSymbol.jsx';
import { isCardTransform, getCardFace } from '../../component/mtg/CardSymbol.jsx';

import { getEndpoint } from '../../context/AppContext.jsx';
import { useTranslation } from "react-i18next";
import { useSave } from '../../context/SaveContext.jsx';
import { useApp } from '../../context/AppContext.jsx';
import { CardImage, CardTextGroup, useCardSrc } from '../../component/mtg/CardSymbol.jsx';
import { MyButton, MyPagination, MyCheckBoxLabel, MyButtonToggle, MyInputLabel, Vr } from '../../component/ui/UI.jsx';
import { usePagination } from '@MyLib/UI/Pagination.jsx';
import { useIsMobile } from "@MyLib/System/Mobile.js";
import { restGetJson } from "@MyLib/System/Rest.js";

const CardSetCanvas = ({ selectedSet }) =>
{
	const [info, setInfo] = useState(null);

	useEffect(() => {
		if (selectedSet)
		{
			(async() => {
				try {
					const query = new URLSearchParams();
					query.append("code", selectedSet.code);
					const data = await restGetJson(`${getEndpoint()}/mtg-sets-code?${query.toString()}`);
					setInfo(data);
				} catch (err) {
					console.error(err);
				}
			})();
		}
	}, [selectedSet]);

	if (!selectedSet || !info) {
		return <div />
	}
	return (
		<div className="card p-1">
			<ul className="list-unstyled mb-0">
				<li><strong>名前：</strong>{info.name}</li>
				<li><strong>コード：</strong>{info.code}</li>
				<li><strong>発売日：</strong>{info.releaseDate}</li>
			</ul>
		</div>
	);
};

const CardCanvas = ({ selectedCard, addSelectCardIndex, onClose }) =>
{
	const { t } = useTranslation();
	const {addKeepCards, removeKeepCards, findKeepCards} = useApp();
	
	const [transform, setTransform] = useState("front");
	const [backCard, setBackCard] = useState();

	useEffect(() =>{
		if (selectedCard)
		{
			logger.log(selectedCard);
			setTransform("front");
			setBackCard(null);
			(async() => {
				if (selectedCard.otherFaceIds)
				{
					try {
						const query = new URLSearchParams();
						query.append("uuid", selectedCard.otherFaceIds.split(',').pop().trim());
						const data = await restGetJson(`${getEndpoint()}/mtg-card?${query.toString()}`);
						setBackCard(data);
					} catch (err) {
						console.error(err);
					}
				}
			})();
		}
	}, [selectedCard]);

	const onTransform = () => {
		if (transform == "front" && backCard)
		{
			setTransform("back");
		}
		else if (transform =="back")
		{
			setTransform("front");
		}
	};

	return (
		<div className="card p-0">
			<div className="row align-items-start m-0">
				<div className="col-auto p-1">
					<CardImage
						card={(transform=="front") ? selectedCard : backCard}
						face={transform}
						uuid={(transform=="front") ? selectedCard.uuid : backCard.uuid}
						language={selectedCard.language}
						onTransform={isCardTransform(selectedCard) ? onTransform : null}
					/>
				</div>
				<div className="col p-1 d-flex flex-column gap-1">
					<div className="d-flex justify-content-between align-items-center">
						<div className='d-flex gap-1'>
							<MyButton onClick={() => {addSelectCardIndex(-1);}} text={t("Common_Previous")} />
							<MyButton onClick={(e) => {addSelectCardIndex(+1);}} text={t("Common_Next")} />
						</div>
						<div className='d-flex gap-1'>
							<MyButtonToggle
								onChange={(e) => {
									if (findKeepCards(selectedCard)) {
										removeKeepCards(selectedCard);
									}
									else {
										addKeepCards([selectedCard]);
									}
								}}
								text={t("AddCard")}
								checked={findKeepCards(selectedCard)}
							/>
							<MyButton text={t("Common_Close")} onClick={onClose} />
						</div>
					</div>
					<CardTextGroup card={selectedCard} other={backCard} transform={transform} />
				</div>
			</div>
		</div>
	);
};

const FilterCanvas = ({ filters, setFilters }) =>
{
	const { t } = useTranslation();

	const handleChange = (e) => {
		const { name, checked } = e.target;
		setFilters((prev) => ({
			...prev,
			[name]: checked,
		}));
	};

	const onChangeToggle = (e, key) => {
		const { name, checked } = e.target;
		setFilters((prev) => ({
			...prev,
			[key]: checked,
		}));
	};

	const onChangeLanguage = (next, key) => {
		setFilters((prev) => ({
			...prev,
			[key]: next,
		}));
	};

	const selectToggles = (field, key) => {
		return filters[field].includes(key);
	};
	const setToggles = (field, key) => {
		setFilters((prev) => ({
			...prev,
			[field]: prev[field].includes(key) ? prev[field].filter(i => i !== key) : [...prev[field], key]
		}));
	};

	return (
		<div className="d-flex align-items-center flex-wrap gap-1">
			<MyInputLabel
				placeholder={t("Card_Name")}
				value={filters.name}
				setValue={(v) => {
					setFilters((prev) => ({...prev, name: v}));
				}}
			/>
			<CardLanguage value={filters.searchLanguage} onChange={(e) => onChangeLanguage(e.target.value, "searchLanguage")} disabledLabel={true} />
			<Vr />
			<CardLanguage value={filters.language} onChange={(e) => onChangeLanguage(e.target.value, "language")} disabledLabel={true} />
			<Vr />
			<WhiteSymbol checked={selectToggles("colors", "W")} onChange={() => setToggles("colors", "W")} />
			<BlueSymbol checked={selectToggles("colors", "U")} onChange={() => setToggles("colors", "U")} />
			<BlackSymbol checked={selectToggles("colors", "B")} onChange={() => setToggles("colors", "B")} />
			<RedSymbol checked={selectToggles("colors", "R")} onChange={() => setToggles("colors", "R")} />
			<GreenSymbol checked={selectToggles("colors", "G")} onChange={() => setToggles("colors", "G")} />
			<ColorlessSymbol checked={selectToggles("colors", "C")} onChange={() => setToggles("colors", "C")} />
			<MyCheckBoxLabel name="AND" value={filters.colorsAnd} onChange={(e)=>{onChangeToggle(e, "colorsAnd")}}/>
			<Vr />
			{CardTypeList().map((item, index) =>
				<MyButtonToggle
					key={index}
					text={item.value}
					checked={selectToggles("types", item.key)}
					onChange={() => setToggles("types", item.key)}
				/>
			)}
			<MyCheckBoxLabel name="AND" value={filters.typesAnd} onChange={(e)=>{onChangeToggle(e, "typesAnd")}}/>
			<Vr />
			{SupertypeList().map((item, index) =>
				<MyButtonToggle
					key={index}
					text={item.value}
					checked={selectToggles("supertype", item.key)}
					onChange={() => setToggles("supertype", item.key)}
				/>
			)}
			<Vr />
			{CardRarityList().map((item, index) => 
				<MyButtonToggle 
					key={index}
					text={item.value}
					checked={selectToggles("rarity", item.key)}
					onChange={() => setToggles("rarity", item.key)}
				/>
			)}
		</div>
	);
};

export const CardSearchImage = ({card, onClick}) => {
	const {filters} = useSave();
	const cardSrc = useCardSrc();

	return (
		<img
			src={cardSrc.getSrc(filters.language, card.setCode, getCardFace(card), card.uuid)}
			onError={cardSrc.onError}
			draggable={false}
			loading="lazy"
			className="img-fluid rounded"
			style={{ cursor: "pointer" }}
			onClick={onClick}
		/>
	);
};

export const CardSearch = () => {
	const {isMobile} = useIsMobile();
	const page = usePagination({limit:40, edgeNum:(isMobile?2:3)});

	const {filters:saveFilters, setFilters:saveSetFilters} = useSave();
	const [filters, setFilters] = useState(saveFilters);
	const {cardSearchCache, setCardSearchCache} = useApp();
	const [useCache, setUseCache] = useState(false);

	const [selectedCardIndex, setSelectedCardIndex] = useState(-1);
	const [selectedCard, setSelectedCard] = useState(null);
	const addSelectCardIndex = (v) => {
		if (page.offset <= selectedCardIndex && selectedCardIndex < page.offset + page.limit)
		{
			const currPage = Math.floor(selectedCardIndex / page.limit) + 1;
			const nextCard = (selectedCardIndex + v + page.total) % page.total;
			setSelectedCardIndex(nextCard);

			const nextPage = Math.floor(nextCard / page.limit) + 1;
			if (currPage != nextPage)
			{
				page.setPageIndex(nextPage);
			}
			else
			{
				setSelectedCard(displayedCards[nextCard % page.limit]);
			}
		}
		else
		{
			const nextCard = page.offset;
			setSelectedCardIndex(nextCard);
			setSelectedCard(displayedCards[nextCard % page.limit]);
		}
	};

	const scrollRef = useRef(null);
	
	const [displayedCards, setDisplayedCards] = useState([]);

	const handleCardClick = (index) => {
		setSelectedCardIndex(index);
		setSelectedCard(displayedCards[index % page.limit]);
		scrollRef.current.scrollTop = 0;
	};

	const getCardsSearchParams = () => {
		const query = new URLSearchParams();
		if (filters.name != "")
		{
			query.append("name", filters.name);
		}
		{
			query.append("language", filters.language);
		}
		{
			query.append("searchLanguage", filters.searchLanguage);
		}
		if (filters.sets.length > 0)
		{
			query.append("setCode", filters.sets);
		}
		if (filters.colors.length > 0)
		{
			query.append("colors", filters.colors);
			if (filters.colorsAnd) {
				query.append("colorsAnd", filters.colorsAnd);
			}
		}
		if (filters.colorsExclude.length > 0)
		{
			query.append("colorsExclude", filters.colorsExclude);
		}
		if (filters.types.length > 0)
		{
			query.append("types", filters.types);
			if (filters.typesAnd) {
				query.append("typesAnd", filters.typesAnd);
			}
		}
		if (filters.supertype.length > 0)
		{
			query.append("supertypes", filters.supertype);
		}
		if (filters.artifactTypes.length > 0 || filters.enchantmentTypes.length > 0 || filters.landTypes.length > 0 || filters.spellTypes.length > 0 || filters.creatureTypes.length > 0 || filters.battleTypes.length > 0)
		{
			query.append("subtypes", [
				...filters.artifactTypes, ...filters.enchantmentTypes, ...filters.landTypes, ...filters.spellTypes, ...filters.creatureTypes, ...filters.battleTypes
			]);
		}
		if (filters.keywords.length > 0)
		{
			query.append("keywords", filters.keywords);
		}
		if (filters.rarity.length > 0)
		{
			query.append("rarity", filters.rarity);
		}
		if (filters.frameEffect.length > 0)
		{
			query.append("frameEffect", filters.frameEffect);
		}
		if (filters.frameEffectExclude.length > 0)
		{
			query.append("frameEffectExclude", filters.frameEffectExclude);
		}
		if (filters.availability.length > 0)
		{
			query.append("availability", filters.availability);
		}
		return query;
	}

	useEffect(() => {
		if (!useCache)
		{
			if (cardSearchCache !== null)
			{
				page.setTotal(cardSearchCache.total);
				page.setPageIndex(cardSearchCache.pageIndex);
				return;
			}
		}

		setSelectedCardIndex(-1);
		{
			page.setTotal(0);
			page.setPageIndex(0);
			setDisplayedCards([]);
			setSelectedCardIndex(-1);

			(async() => {
				try {
					const query = getCardsSearchParams();
					const data = await restGetJson(`${getEndpoint()}/mtg-cards-count?${query.toString()}`);
					page.setTotal(data.total);
					page.setPageIndex(1);
				} catch (err) {
					console.error(err);
				}
			})();
		}

		saveSetFilters(filters);
		setCardSearchCache(null);
	}, [filters]);

	useEffect(() => {
		if (!useCache)
		{
			setUseCache(true);
			if (cardSearchCache !== null)
			{
				console.log("AAAAAAAAAAA")
				setDisplayedCards(cardSearchCache.displayCards);
				setCardSearchCache(null);
				return;
			}
		}

		if (page.pageIndex > 0)
		{
			(async() => {
				try {
					const query = getCardsSearchParams();
					query.append("limit", page.limit);
					query.append("offset", page.offset);
					const cardList = await restGetJson(`${getEndpoint()}/mtg-cards-range?${query.toString()}`);
					setDisplayedCards(cardList);
					if (page.offset <= selectedCardIndex && selectedCardIndex < page.offset + page.limit)
					{
						setSelectedCard(cardList[selectedCardIndex % page.limit]);
					}

					setCardSearchCache({
						total: page.total,
						displayCards: cardList,
						pageIndex: page.pageIndex,
					});
					scrollRef.current.scrollTop = 0;// TODO scrollTopヌルポ
				} catch (err) {
					console.error(err);
				}
			})();
		}
	}, [page.pageIndex]);

	return (
		<div className="container-fluid h-100 p-0">
			<div
				ref={scrollRef}
				className="h-100 d-flex flex-column p-1 gap-1"
				style={{ overflowY: "auto", overflowX: "hidden" }}
			>
				{/* 選択カード詳細 */}
				{selectedCard && (
					<CardCanvas
						selectedCard={selectedCard} addSelectCardIndex={addSelectCardIndex}
						onClose={()=>setSelectedCard(null)}
					/>
				)}
				{/* フィルター */}
				<FilterCanvas filters={filters} setFilters={setFilters} />
				{/* ページ切り替え */}
				<MyPagination page={page} />
				{/* カード一覧 */}
				{(
					<div className="row row-cols-2 row-cols-sm-2 row-cols-md-4 row-cols-lg-5 g-1">
						{displayedCards.map((card, index) => (
							<div
								key={card.uuid}
								className="col text-center"
							>
								<CardSearchImage
									card={card}
									onClick={() => handleCardClick(page.offset+index)}
								/>
							</div>
						))}
					</div>
				)}
				{/* ページ切り替え */}
				<MyPagination page={page} />
			</div>
		</div>
	);
};
